import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBadgrComponent } from './simple-icons-badgr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBadgrComponent ],
    exports:      [ SimpleIconsBadgrComponent ],
    bootstrap:    []
})
export class SimpleIconsBadgrModule {}
